import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

export default function BackToTop() {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const onScroll = () => setVisible(window.scrollY > 600);
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    const scrollTop = () => {
        if (window.__lenis) {
            window.__lenis.scrollTo(0, { duration: 1.2 });
        } else {
            window.scrollTo({ top: 0, behavior: "smooth" });
        }
    };

    return (
        <AnimatePresence>
            {visible && (
                <motion.button
                    key="btt"
                    type="button"
                    data-testid="back-to-top"
                    onClick={scrollTop}
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: 20 }}
                    transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
                    className="group fixed bottom-6 right-6 md:bottom-10 md:right-10 z-40 inline-flex items-center gap-3 pl-4 pr-5 py-3 bg-[#1B1B1B] text-[#F6F3EC] border border-[#1B1B1B] transition-colors duration-500 hover:bg-[#A8844F] hover:border-[#A8844F]"
                    aria-label="Back to top"
                >
                    <svg
                        className="w-4 h-4 transition-transform duration-500 group-hover:-translate-y-1"
                        viewBox="0 0 16 16"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="1.4"
                    >
                        <path d="M8 14V2M2 8l6-6 6 6" />
                    </svg>
                    <span className="font-sans-tight text-[10px] tracking-[0.24em] uppercase">
                        Top
                    </span>
                </motion.button>
            )}
        </AnimatePresence>
    );
}
